import { useState } from 'react';
import { Button, Col, Form, InputNumber, Row, Typography } from 'antd';
import { CaretDownOutlined, CaretUpOutlined, LoadingOutlined, SaveOutlined } from '@ant-design/icons';

const { Text } = Typography;

const saveButtonStates = {
    default: {
        icon: (<SaveOutlined/>),
        type: "primary"
    },
    changed: {
        icon: (<SaveOutlined/>),
        type: "danger"
    },
    saving: {
        icon: (<LoadingOutlined/>),
        type: "danger"
    }
}

function SLPLine(props) {

    const [ position, setPosition ] = useState(null);
    const [ savedProps, setSavedProps ] = useState({});
    const [ saveButton, setSaveButton ] = useState(saveButtonStates.default);

    if (props !== savedProps) {
        //console.log("props changed");
        setSavedProps(props);
        setPosition(props.participant.position);
    }

    const changeOrder = async order => {
        //console.log(order);
        setSaveButton(saveButtonStates.saving);
        await props.onChangeOrder(props.participant.id, props.participant.association, order);
        setSaveButton(saveButtonStates.default);
    };

    const inputChanged = i => {
        setPosition(i);
        setSaveButton(saveButtonStates.changed);
    }

    return (
        <Form
            fields={[
                {
                    name: ["position"],
                    value: position
                }
            ]}
            //onFinish={() => changeOrder(formRef.current.getFieldValue("position"))}
            //onFinish={values => console.log(values)}
            onFinish={values => changeOrder(values.position)}
        >
            <Row style={{marginTop:10}}>
                <Col span={3}>
                    <Form.Item
                        name="position"
                        noStyle={true}
                    >
                        <InputNumber onChange={inputChanged}/>
                    </Form.Item>
                </Col>
                <Col span={12} style={{marginTop: "5px"}}>
                    <Text>
                        {props.participant.lastName + " " + props.participant.firstName}
                    </Text>
                </Col>
                <Col span={5} style={{marginTop: "5px"}}>
                    <Text>
                        {props.participant.association}
                    </Text>
                </Col>
                <Col span={4}>
                    <Button 
                        disabled={!props.participant.position || props.type.includes("first")}
                        icon={<CaretUpOutlined/>}
                        onClick={() => changeOrder(props.participant.position-1)}
                    />
                    <Button
                        disabled={!props.participant.position || props.type.includes("last")}
                        icon={<CaretDownOutlined/>}
                        onClick={() => changeOrder(props.participant.position+1)}
                    />
                    <Button
                        htmlType="submit"
                        type={saveButton.type}
                        icon={saveButton.icon}
                    />
                </Col>
            </Row>
        </Form>
    );
}

export default SLPLine;